// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PuzJdFmr {
  position: relative;
  overflow: hidden;
}

._Ef8TLHm {
  width: 100%;
  height: auto;
  transition: opacity 0.3s ease;
}

.D3sJYpq2 {
  opacity: 0.7;
}

.aB2PRjET {
  opacity: 1;
}

.g1cGS7_M {
  filter: grayscale(100%);
}

._zsz93Va {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 12px;
  pointer-events: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PuzJdFmr`,
	"image": `_Ef8TLHm`,
	"loading": `D3sJYpq2`,
	"loaded": `aB2PRjET`,
	"error": `g1cGS7_M`,
	"loadingOverlay": `_zsz93Va`
};
export default ___CSS_LOADER_EXPORT___;
